/**
 * ============================================
 * SAHINKAYA_GUNCELLEMESI - PRODUCT SHARE BUTTON JS
 * Tarih: Mart 2026
 * ============================================
 */

document.addEventListener('click', (e) => {
  const btn = e.target.closest('.product-share-btn');
  if (!btn) return;

  const title = btn.dataset.shareTitle || document.title;
  const url   = btn.dataset.shareUrl   || window.location.href;

  if (navigator.share) {
    navigator.share({ title, url }).catch(() => {});
  } else {
    navigator.clipboard.writeText(url).then(() => {
      btn.setAttribute('data-copied', '1');
      const tooltip = btn.querySelector('.product-share-btn__tooltip');
      if (tooltip) tooltip.style.opacity = '1';
      setTimeout(() => {
        btn.removeAttribute('data-copied');
        if (tooltip) tooltip.style.opacity = '';
      }, 2000);
    }).catch(() => {});
  }
});
